import React, { createContext, useContext, useEffect, useState } from "react";

const ShopContext = createContext(null);
export const useShop = () => useContext(ShopContext);

const load = (key, fallback) => {
  try {
    const v = localStorage.getItem(key);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};

export const ShopProvider = ({ children }) => {
  const [cart, setCart] = useState(() => load("shiokoi_cart", []));
  const [fitProfile, setFitProfile] = useState(() => load("shiokoi_fit", null));

  useEffect(() => {
    localStorage.setItem("shiokoi_cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    if (fitProfile) localStorage.setItem("shiokoi_fit", JSON.stringify(fitProfile));
  }, [fitProfile]);

  const addToCart = (item) => {
    setCart((prev) => [...prev, { ...item, lineId: `${Date.now()}-${Math.random()}` }]);
  };
  const removeFromCart = (lineId) => setCart((prev) => prev.filter((i) => i.lineId !== lineId));
  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((n, i) => n + (i.qty || 1), 0);
  const cartTotal = cart.reduce((n, i) => n + i.price * (i.qty || 1), 0);

  return (
    <ShopContext.Provider
      value={{ cart, addToCart, removeFromCart, clearCart, cartCount, cartTotal, fitProfile, setFitProfile }}
    >
      {children}
    </ShopContext.Provider>
  );
};
